import { FC } from 'react';
import styled from 'styled-components';


export type Status = 'success' | 'warning' | 'error';

interface StatusIndicatorProps {
    statusClass: Status;
}

const StatusIndicator: FC<StatusIndicatorProps> = (props) => {

    return <Indicator statusClass={props.statusClass} aria-label="status indicator"/>;
};

export default StatusIndicator;


const Indicator = styled.span<StatusIndicatorProps>`
display: inline-block;
height: 8px;
width: 8px;
border-radius: 50%;
background-color: ${props => props.theme.colors[props.statusClass]};
`;